export default class AppConfig {
  public static apiEndpoint() {
    if (process.env.VUE_APP_SYMBOL_API_ENDPOINT) {
      return process.env.VUE_APP_SYMBOL_API_ENDPOINT;
    }
    return '';
  }

  public static generationHash() {
    if (process.env.VUE_APP_GENERATION_HASH_SEED) {
      return process.env.VUE_APP_GENERATION_HASH_SEED;
    }
    return '';
  }

  public static feeMultiplier() {
    return Number(process.env.VUE_APP_FEE_MULTIPLIER);
  }

  public static epochAdjustment() {
    return Number(process.env.VUE_APP_EPOCH_ADJUSTMENT);
  }

  public static networkType() {
    return Number(process.env.VUE_APP_NETWORK_TYPE);
  }
}
